import { WIZARD_STEP } from '../SourceCreate.constants';
import type { SelectedSource } from '../SourceSelectionStep';
import type {
  UseWizardNavigationParams,
  UseWizardNavigationReturn
} from './SourceCreateDialog.types';

/**
 * Custom hook to manage wizard navigation for the multi-step source creation flow.
 *
 * Handles:
 * - Moving forward from source selection to configuration
 * - Moving back from configuration to source selection
 * - Selecting a source in step 1
 *
 * @param params - Current step state and setters
 * @returns Navigation handlers
 */
export const useWizardNavigation = ({
  currentStep,
  setCurrentStep,
  wizardSelectedSource,
  setWizardSelectedSource
}: UseWizardNavigationParams): UseWizardNavigationReturn => {
  const handleNext = () => {
    if (currentStep === WIZARD_STEP.SELECT_SOURCE && wizardSelectedSource) {
      setCurrentStep(WIZARD_STEP.CONFIGURE_SOURCE);
    }
  };

  const handleBack = () => {
    if (currentStep === WIZARD_STEP.CONFIGURE_SOURCE) {
      setCurrentStep(WIZARD_STEP.SELECT_SOURCE);
    }
  };

  const handleSourceSelect = (source: SelectedSource) => {
    // Simply set the selected source - form is already clean from Step 1 mount
    setWizardSelectedSource(source);
  };

  return {
    handleNext,
    handleBack,
    handleSourceSelect
  };
};
